import Player from '@vimeo/player';
import { debounce as _debounce } from 'underscore';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger);

// Vimeo Player SDK:  https://developer.vimeo.com/player/sdk
const console = window.console;

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false

        	,background: true
        	,autoplay: true

        	,pauseOnStart: false
        	,autopause: true

        	,playPause: false

        	,trackGAEvents: true

        	,debug: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'vimeoplayer';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

		this.$window 		= 	$(window);
		this.playClicked 	= 	false; // userClick!
		this.playing 		= 	false

		if ( this.options.playPause ){
			this.$playPause 	= 	this.$el.find( '.play-pause' );
		}

		if ( !this.$el.hasClass( 'js-init' ) ){
			this.init();
		}
    }

    init(){

    	this.$iframe = this.$el.find( 'iframe' );

console.log('Videoplayer.js', this.$iframe);

    	if ( this.$iframe.length > 0 ){

    		// already add by php the class 'video-vimeo' ... just a formality
    		this.isVimeo = this.$iframe.attr( 'src' ).indexOf( 'vimeo' ) !== -1;
    		if ( this.isVimeo ){
				// already add by php ... just a formality
				this.$el.addClass( 'video-vimeo' );
    			this.initVimeo( true )
    		}

    		this.addEvents( true );
    	
    	}
    	else{

    		if ( this.$el.hasClass( 'js-init' ) ){
    			this.onError(  {name: 'Notice', message:'this video has to be initialized by JS'} );
    		}
    		else{
    			this.onError(  {name: 'missing element', message:'iframe is missing to vimeoPlayer'} );
    		}

    		this.$el.trigger( 'video::load-error' );
    	}
	}

	loadVideo(){
		let $script = this.$el.find( 'script.video-to-load' );
		if ( $script.length > 0 ){
			this.$el.find( '.iframe-container' ).html( $script.html() );
			this.$el.removeClass( 'js-init' );
			this.init();
		}
		else{
			this.$el.trigger( 'video::load-error' );
		}
	}

	initVimeo( b ){
		if ( b ){
			// Vimeo SDK init
			this.player = new Player( this.$iframe[0] );
			this.player.ready().then( 
				()=>this.onVideo( 'ready' ) 
			).catch((error)=>this.onError(error));
		}
		else{
    		this.player.destroy().then(function() {
			    // the player was destroyed
			}).catch((error)=>this.onError(error));
		}
		if ( this.options.autopause ){
			this.initAutoPause( b );
		}
	}

	initAutoPause( b ){
		if ( b ){
			this.scrollTriggerId = this.namespace + '_' + Math.random();
			
			ScrollTrigger.create({
				id: this.scrollTriggerId
				,scrub: true
				,trigger: this.$el
				,toggleClass: 'auto-in-view'
				,scroller: $(this.main.options.$scroll_el)
				,onToggle: (e) => {
					//console.log( e );
					this.forceAutoPause( !e.isActive );
				}
				//,markers: true
			});
		}
		else{
			ScrollTrigger.getById( this.scrollTriggerId ).kill();
		}
	}

	 //---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){

			if ( this.isVimeo ){
				this.player.on( 'error', 	(e)=>this.onVideo( 'error', e ) );
				this.player.on( 'loaded', 	(e)=>this.onVideo( 'load', e ) );
				this.player.on( 'bufferend',(e)=>this.onVideo( 'bufferend', e ) );
				this.player.on( 'play', 	(e)=>this.onVideo( 'play', e ) );
				this.player.on( 'pause', 	(e)=>this.onVideo( 'pause', e ) );
				this.player.on( 'ended', 	(e)=>this.onVideo( 'ended', e ) );
                this.$el.on('click', 'A[rel="video-player:audio"]', (e)=>this.audio( b ));
			}

			if ( this.options.playPause && this.$playPause.length > 0 ){
				this.$playPause.on( 'click', 	()=>{ this.togglePlay(); return false; });
			}

		}
		else{

			if ( this.isVimeo ){
				this.player.off( 'error', 	(e)=>this.onVideo( 'error', e ) );
				this.player.off( 'loaded', 	(e)=>this.onVideo( 'load', e ) );
				this.player.off( 'bufferend',(e)=>this.onVideo( 'bufferend', e ) );
				this.player.off( 'play', 	(e)=>this.onVideo( 'play', e ) );
				this.player.off( 'pause', 	(e)=>this.onVideo( 'pause', e ) );
				this.player.off( 'ended', 	(e)=>this.onVideo( 'ended', e ) );
                this.$el.off('click', 'A[rel="video-player:audio"]', (e)=>this.audio( b ));
			}

			if ( this.options.playPause && this.$playPause.length > 0 ){
				this.$playPause.off( 'click', 	()=>this.togglePlay() );
			}

		}
		this.debounceResize(b);
	}

    debounceResize( b ){
		if ( b ){
			// debounce resize
			this._debResize = _debounce( () => {
				this.onResize();
			}, 77 );
			this.$window.on( 'resize', this._debResize );

			this.onResize()
		}
		else{
			if ( this._debResize ){
				this._debResize.cancel();
				this.$window.off( 'resize', this._debResize );
			}        
		}
    }

    onVideo( state, e ){
    	if ( this.options.debug ){
    		console.log(  'onVideo, state = ' + state );
    	}
    	
    	switch( state ){
    		case 'error':
    			this.onError( { name: 'video state', message: 'Video State Error' } );
    			this.onError( e );
    		break;
    		case 'ready':

    			// this is fired when Vimeo SDK is ready
    			if ( this.options.autoplay && this.options.background ){
    				this.player.setMuted( true ).then(()=>{
    					this.play(true);
    				}).catch( (error) => this.onError( error ) )
    			}

    			this.initVimeoPlayStart();

    		break;
    		case 'load':
     			setTimeout( ()=>this.$el.addClass( 'video-load' ).addClass( 'video-ready' ), this.options.background ? 600 : 17 );
    		break;
    		case 'bufferend':    		
    		break;
    		case 'play':
    			if ( ! this.$el.hasClass( 'first-play' ) ){
    				this.$el.addClass( 'first-play' );
    			}
    			this.$el.addClass( 'video-play' );
    			this.$el.removeClass( 'video-pause' );
    			this.playing = true;

    			if ( this.options.autoplay && this.options.pauseOnStart && !this.options.autopause ){
    				setTimeout( () => this.play( false ), 600 );
    				this.options.pauseOnStart = false;
    			}

		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Video Play', 'Video Play', this.$iframe.attr( 'src' ) , document.location.href  );
		    	}


    		break;
    		case 'pause':
    			this.$el.removeClass( 'video-play' );
    			this.$el.addClass( 'video-pause' );
    			this.playing = false

		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Video Pause', 'Video Pause', this.$iframe.attr( 'src' ) , document.location.href  );
		    	}


    		break;
    		case 'ended':
    		break;
    	}

    	this.$el.trigger( 'video::' + state );
    }

    onError( error ){
    	let str = this.namespace + ' : ';
		switch (error.name) {
			case 'PasswordError':
				str += 'The video is password-protected';
			break;
			case 'PrivacyError':
				str += 'The video is private';
			break;
			default:
				str += error.message;
		}
		if ( this.options.debug ){
			console.log( error );
			console.log( str );
		}
    }

    onResize(){
    	const w_video = parseInt( this.$iframe.attr('width')  ), 
    		  h_video = parseInt( this.$iframe.attr('height') );


    	//console.log( 'video player resize' );

    	// size to fit the container avail space
		if ( this.$el.hasClass( 'video-size-cover' ) ){
			let $container = this.$el.parent(),
				w = $container.width(), 
				h = $container.height(),
				// get max avail proportion
				p = Math.max( w/w_video, h/h_video );

				// console.log( w + ','  + h );

			this.$iframe.width(	 Math.ceil(w_video*p) );
			this.$iframe.height( Math.ceil(h_video*p) );

			// just in case is not already set with css
			$container.css({
				overflow: 'hidden'
			})
		}
		else if ( this.$el.hasClass( 'video-size-auto' ) ) {
			// autosize video by its proportions
			this.$el.find( '.embed-wrapper' ).css({
				'padding-bottom' : (h_video/w_video*100) + '%'
			})
		}

		if ( this.options.autopause ){
			ScrollTrigger.refresh();
		}
    }

	initVimeoPlayStart(){
		if ( this.$el.hasClass( 'embed-mode-play-button-start' ) ){
			this.$el.find(  '.overlay-video' ).on( 'click', (e)=>{

				let url = this.$iframe.attr( 'src' ).split( '?' )[0], 
					$overlay = this.$el.find(  '.overlay-video' ),
					$iframe = this.$el.find( '.iframe-container' );


				gsap.set( $overlay, {'pointer-events': 'none'} );

				// create a new vimeo player with controls
				let p = new Player( $iframe[0], {
					controls: 1,
	                hd : 1,
	                autohide: 1,
	                autoplay: 1,
	                title: 0,
	                byline: 0,
	                portrait: 0,
	                badge: 0,
					url: url
				});

		    	if ( this.options.trackGAEvents ){
					this.main.setGAEvent(  'Video Play', 'Video Play', this.$iframe.attr( 'src' ) , document.location.href  );
		    	}

				// opacity transition on top of the other iframe
				gsap.fromTo( $iframe, {opacity:0},{opacity:1, duration:2, onComplete:()=>{
					// destroy precedent player
					this.destroy();


					setTimeout( ()=>{
						this.player = p;
						this.addEvents( true );						
					}, 2000 );


				}});

				// remove play
				gsap.to( $overlay, {opacity:0, duration:0.6, onComplete:()=>{
					$overlay.remove();
				}});

			});
		}
	}    

    //---------------------------------------- METHODS ---------------------------------------//

    play( b ){
    	if ( b ){

    		if ( this.isVimeo ){
				this.player.play().then(()=>{
				  // The video is playing
				}).catch( (error) => this.onError( error ) )
			}

    	}
    	else{

    		if ( this.isVimeo ){
				this.player.pause().then(()=>{
				  // The video is paused
				}).catch( (error) => this.onError( error ) )
			}

    	}

	}

    audio( b ){
        if ( b ){
            if ( this.isVimeo ){

                let button = this.$el.find('A[rel="video-player:audio"]');
                if (button.hasClass('active')) {
                    button.removeClass('active');
                    this.player.setVolume(0);
                } else {
                    button.addClass('active');
                    this.player.setVolume(1);
                }
            }
        }
        // this.$el.find('A[rel="video-player:audio"]').fadeOut(400);
        return false;
    }


    // fired from button play/pause
    togglePlay(){
    	if ( this.isVimeo ){
			this.player.getPaused().then( (paused) => {
			  	// `paused` indicates whether the player is paused
			  	this.play( paused );
			  	this.playClicked = paused;
			})
		}
    }

    // fired by ScrollTrigger if this.options.autopause is true
    forceAutoPause( b ){
    	if ( this.isVimeo ){
			if ( this.options.background && this.options.autoplay ){
				// background mode autoplay, play/pause if in view/out of view
				this.play( !b );
			}
			else if ( this.options.background && !this.options.autoplay && this.playClicked ){
				// set to mute only if the video is playing because user playClicked
				if ( b ){
					this.play( false );
					this.playClicked = false
				}
			}
			else{
				// normal embed, just pause if out of view
				if ( b ){
					this.play( false );
				}
			}
    	}
    }

    destroy(){
    	this.addEvents( false );
    	if ( this.isVimeo ){
    		this.initVimeo( false );
    	}
    }

}


